<template>
	<el-input-number class="noButton" autocomplete="off" size="small" v-limit-number="$attrs.scale" v-bind="$attrs" v-on="$listeners" />
</template>

<script>
export default {
	name: 'baseInputNumber'
};
</script>
<style></style>
